import React, { useEffect, useState } from 'react'
import { Form, Spinner } from 'react-bootstrap'

import { getFormatTypes } from '../../FormatTypes/services'
import { handleError } from '../../../helpers'

export default function ReportDetailForm({ register, errors, editable, serviceReport }) {
	const [options, setOptions] = useState(null)

	useEffect(() => {
		!options && serviceReport && getFormatTypes({
			'filter[format_type]':'report_format',
			'filter[format_id]': serviceReport.report_format.id,
			'filter[setting_type]': 'detail_type',
			include: 'setting'
		})
			.then(res => setOptions(res.data.data))
			.catch(handleError)
	}, [ options, serviceReport ])

	if(!options && serviceReport) 
		return <div className='mb-10'><Spinner animation='border' size="sm" /></div>

	return (
		<React.Fragment>
			{ !editable && (
				<Form.Group className='form-group'>
					<Form.Label>Resultado a ingresar <span className='text-danger'>*</span></Form.Label>
					<Form.Control 
						as="select"
						{...register('detail_type_id', { required: true })}
					>
						<option value="">:: Seleccione una opción ::</option>
						{ options.map(opt => (
							<option key={opt.setting.id} value={opt.setting.id}>
								{opt.setting.name}
							</option>
						)) }
					</Form.Control>
					{ errors.detail_type_id && <Form.Text className='text-warning'>Este campo es requerido</Form.Text> }
				</Form.Group>
			)}
			<Form.Group className='form-group'>
				<Form.Label>Detalle del resultado <span className='text-danger'>*</span></Form.Label>
				<Form.Control 
					{...register('comment', { required:true })}
					placeholder="Escriba aquí..."
				/>
				{ errors.comment && <Form.Text className='text-warning'>Este campo es requerido</Form.Text> }
			</Form.Group>
		</React.Fragment>
	)
}